<template>
    <div class="app-container">
        <el-row :gutter="10" class="mb8">
            <el-col :span="1.5">
                <el-button
                    type="primary"
                    icon="el-icon-plus"
                    size="mini"
                    @click="handleAdd"
                >新增
                </el-button>
            </el-col>
            <!--      <el-col :span="1.5">-->
            <!--        <el-button-->
            <!--            type="success"-->
            <!--            icon="el-icon-edit"-->
            <!--            size="mini"-->
            <!--            :disabled="single"-->
            <!--            @click="handleUpdate"-->
            <!--        >修改-->
            <!--        </el-button>-->
            <!--      </el-col>-->
            <el-col :span="1.5">
                <el-button
                    type="danger"
                    icon="el-icon-delete"
                    size="mini"
                    :disabled="multiple"
                    @click="handleDelete"
                >删除
                </el-button>
            </el-col>

            <!--      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>-->
        </el-row>

        <div class="list">
            <el-table v-loading="loading" :data="fangxingList" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55" align="center"/>
                <!--      <el-table-column label="${comment}" align="center" prop="id" />-->
                <el-table-column label="房型名称" align="center" prop="fangName"/>
                <el-table-column label="宣传图" align="center" prop="fangImg" width="100">
                    <template slot-scope="scope">
                        <el-image v-if="scope.row.fangImg" :src="showFirstImage(scope.row.fangImg)" :width="50"
                                  :height="50"/>
                    </template>
                </el-table-column>
                <el-table-column label="租金/月(元)" align="center" prop="zuJin">
                    <template slot-scope="scope">
                        <label>{{ scope.row.zuJin / 100 }}</label>
                    </template>
                </el-table-column>
                <el-table-column label="物业费/月(元)" align="center" prop="wuYeFei">
                    <template slot-scope="scope">
                        <label>{{ scope.row.wuYeFei / 100 }}</label>
                    </template>
                </el-table-column>
                <el-table-column label="押金(元)" align="center" prop="yaJin">
                    <template slot-scope="scope">
                        <label>{{ scope.row.yaJin / 100 }}</label>
                    </template>
                </el-table-column>
                <el-table-column label="房间大小m²" align="center" prop="fangSize"/>
                <el-table-column label="层数" align="center" prop="fangCeng"/>
                <el-table-column label="wifi" align="center" prop="fangWifi">
                    <template slot-scope="scope">
                        <label v-if="scope.row.fangWifi==1">有</label>
                        <label v-if="scope.row.fangWifi==2">无</label>
                    </template>
                </el-table-column>
                <el-table-column label="窗户" align="center" prop="fangChuang">
                    <template slot-scope="scope">
                        <label v-if="scope.row.fangChuang==1">有</label>
                        <label v-if="scope.row.fangChuang==2">无</label>
                    </template>
                </el-table-column>
                <el-table-column label="吸烟" align="center" prop="fangYan">
                    <template slot-scope="scope">
                        <label v-if="scope.row.fangYan==1">允许</label>
                        <label v-if="scope.row.fangYan==2">禁止</label>
                    </template>
                </el-table-column>
                <el-table-column label="顺序" align="center" prop="imgOrder"/>
                <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
                    <template slot-scope="scope">
                        <el-button
                            size="mini"
                            type="text"
                            icon="el-icon-edit"
                            @click="handleUpdate(scope.row)"
                        >修改
                        </el-button>
                        <el-button
                            size="mini"
                            type="text"
                            icon="el-icon-delete"
                            @click="handleDelete(scope.row)"
                        >删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <pagination
                v-show="total>0"
                :total="total"
                :page.sync="queryParams.pageNum"
                :limit.sync="queryParams.pageSize"
                @pagination="getList"
            />
        </div>

        <!-- 添加或修改房型设置对话框 -->
        <el-dialog :title="title" :visible.sync="open" width="800" append-to-body>
            <el-form ref="form" :model="form" :rules="rules" label-width="120px">
                <el-form-item label="房型名称" prop="fangName">
                    <el-input v-model="form.fangName" placeholder="请输入房型名称"/>
                </el-form-item>
                <el-form-item label="宣传图" prop="fangImg">
                    <!--          <image-upload v-model="form.fangImg"/>-->
                    <upload-image-url ref="uploadImage" :image-count="9"
                                      @notifyUploadCoverImage="handleImageUpload"></upload-image-url>
                </el-form-item>
                <el-form-item label="租金/月(元)" prop="zuJin">
                    <el-input v-model="form.zuJin" placeholder="请输入租金/月(元)"/>
                </el-form-item>
                <el-form-item label="物业费/月(元)" prop="wuYeFei">
                    <el-input v-model="form.wuYeFei" placeholder="请输入物业费/月(元)"/>
                </el-form-item>
                <el-form-item label="押金(元)" prop="yaJin">
                    <el-input v-model="form.yaJin" placeholder="请输入押金(元)"/>
                </el-form-item>
                <el-form-item label="房间大小m²" prop="fangSize">
                    <el-input v-model="form.fangSize" placeholder="请输入房间大小m²"/>
                </el-form-item>
                <el-form-item label="层数" prop="fangCeng">
                    <el-input v-model="form.fangCeng" placeholder="请输入层数"/>
                </el-form-item>
                <el-form-item label="wifi" prop="fangWifi">
                    <el-radio v-model="form.fangWifi" label="1">有</el-radio>
                    <el-radio v-model="form.fangWifi" label="2">无</el-radio>
                </el-form-item>
                <el-form-item label="窗户" prop="fangChuang">
                    <el-radio v-model="form.fangChuang" label="1">有窗</el-radio>
                    <el-radio v-model="form.fangChuang" label="2">无窗</el-radio>
                </el-form-item>
                <el-form-item label="吸烟" prop="fangYan">
                    <el-radio v-model="form.fangYan" label="1">允许</el-radio>
                    <el-radio v-model="form.fangYan" label="2">禁止</el-radio>
                </el-form-item>
                <el-form-item label="家电类">
                    <el-checkbox-group v-model="form.fangBuju">
                        <el-checkbox label="电视" name="type"></el-checkbox>
                        <el-checkbox label="冰箱" name="type"></el-checkbox>
                        <el-checkbox label="洗衣机" name="type"></el-checkbox>
                        <el-checkbox label="抽油烟机" name="type"></el-checkbox>
                        <el-checkbox label="热水器" name="type"></el-checkbox>
                        <el-checkbox label="WIFI" name="type"></el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="家具类">
                    <el-checkbox-group v-model="form.fangWuzhangai">
                        <el-checkbox label="衣柜" name="type"></el-checkbox>
                        <el-checkbox label="书桌" name="type"></el-checkbox>
                        <el-checkbox label="凳子" name="type"></el-checkbox>
                        <el-checkbox label="1.8 米床" name="type"></el-checkbox>
                        <el-checkbox label="高级弹簧床垫" name="type"></el-checkbox>
                        <el-checkbox label="餐桌" name="type"></el-checkbox>
                        <el-checkbox label="餐椅" name="type"></el-checkbox>
                        <el-checkbox label="沙发" name="type"></el-checkbox>
                        <el-checkbox label="茶几" name="type"></el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="家居用品类">
                    <el-checkbox-group v-model="form.fangWangluo">
                        <el-checkbox label="晾衣架" name="type"></el-checkbox>
                        <el-checkbox label="电动晾衣架" name="type"></el-checkbox>
                        <el-checkbox label="窗帘" name="type"></el-checkbox>
                        <el-checkbox label="镜子" name="type"></el-checkbox>
                        <el-checkbox label="钟表" name="type"></el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="建筑设施类">
                    <el-checkbox-group v-model="form.fangWeiyu">
                        <el-checkbox label="窗户" name="type"></el-checkbox>
                        <el-checkbox label="独立卫生间" name="type"></el-checkbox>
                        <el-checkbox label="24小时热水" name="type"></el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="室外景观">
                    <el-checkbox-group v-model="form.fangJingguan">
                        <el-checkbox label="山景" name="type"></el-checkbox>
                        <el-checkbox label="海景" name="type"></el-checkbox>
                        <el-checkbox label="城景" name="type"></el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="顺序" prop="imgOrder">
                    <el-input v-model="form.imgOrder" placeholder="请输入顺序"/>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="cancel">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {fangxingList, addFangxing, editFangxing, getFangxingInfo, delFangxing,getTo} from "@/api/homestay/api";
import UploadImageUrl from '@/components/upload/UploadImageUrl'

export default {
    name: "Fangxing",
    components: {
        UploadImageUrl
    },
    data() {
        return {
            // 根路径
            baseURL: process.env.VUE_APP_BASE_API,
            // 遮罩层
            loading: false,
            // 选中数组
            ids: [],
            // 非单个禁用
            single: true,
            // 非多个禁用
            multiple: true,
            // 显示搜索条件
            showSearch: true,
            // 总条数
            total: 0,
            // 房型设置表格数据
            fangxingList: [],
            // 弹出层标题
            title: "",
            // 查询参数
            queryParams: {
                pageNum: 1,
                pageSize: 10,
                idCard: "",
                name: "",
                link: "",
                personRole: "",
                // page:"1",
                // row:"10",
                personType: "",
                communityId: "",
                roomName: ""
            },
            // 是否显示弹出层
            open: false,
            // 表单参数
            form: {},
            // 表单校验
            rules: {
                id: [
                    {required: true, message: "$comment不能为空", trigger: "blur"}
                ],
                fangName: [
                    {required: true, message: "房型名称不能为空", trigger: "blur"}
                ],
                fangImg: [
                    {required: true, message: "宣传图不能为空", trigger: "blur"}
                ],
                zuJin: [
                    {required: true, message: "租金/月(分)不能为空", trigger: "blur"}
                ],
                wuYeFei: [
                    {required: true, message: "物业费/月(分)不能为空", trigger: "blur"}
                ],
                yaJin: [
                    {required: true, message: "押金(分)不能为空", trigger: "blur"}
                ],
                fangSize: [
                    {required: true, message: "房间大小m²不能为空", trigger: "blur"}
                ],
                fangCeng: [
                    {required: true, message: "层数不能为空", trigger: "blur"}
                ],
                fangWifi: [
                    {required: true, message: "wifi 1有 2无不能为空", trigger: "blur"}
                ],
                fangChuang: [
                    {required: true, message: "窗户 1有床 2无床不能为空", trigger: "blur"}
                ],
                fangYan: [
                    {required: true, message: "吸烟 1允许 2进制不能为空", trigger: "blur"}
                ],
                imgOrder: [
                    {required: true, message: "顺序不能为空", trigger: "blur"}
                ]
            }
        };
    },
    created() {
        this.getList();
        this.aaa();
    },
    methods: {
        aaa(){
          getTo().then(response => {
            console.log('====  ' + response)
          });
        },
        showFirstImage(imgstr) {
            let arr = imgstr.split(",");
            return arr[0];
        },
        handleImageUpload(images) {
            //this.form.fangImg = images
            for (let i = 0; i < images.length; i++) {
                this.form.fangImg = this.form.fangImg + ',' + images[i];
            }
            //console.log('====  ' + this.form.fangImg)
        },
        /** 查询房型设置列表 */
        getList() {
            this.loading = true;
            fangxingList(this.queryParams).then(response => {
                this.fangxingList = response.data;
                this.total = response.total;
                this.loading = false;
            });
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.reset();
        },
        // 表单重置
        reset() {
            this.form = {
                id: null,
                fangName: null,
                fangImg: null,
                zuJin: null,
                wuYeFei: null,
                yaJin: null,
                fangSize: null,
                fangCeng: null,
                fangWifi: null,
                fangChuang: null,
                fangYan: null,
                fangBuju: [],
                fangWuzhangai: [],
                fangWangluo: [],
                fangWeiyu: [],
                fangJingguan: [],
                // fangKefang: [],
                // fangMeiti: [],
                // fangChufang: [],
                imgOrder: null,
                delFlag: null,
            };
            this.resetForm("form");

        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            //this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.resetForm("queryForm");
            this.handleQuery();
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.id)
            this.single = selection.length !== 1
            this.multiple = !selection.length
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.reset();

            this.open = true;
            this.title = "添加房型设置";

            setTimeout(() => {
                this.$refs.uploadImage.clearImages();
                this.$refs.uploadImage.fillphotos(this.form.fangImg);
            }, 1000)
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.reset();
            const idss = (row.id || this.ids.join(','));
            console.log(idss)
            getFangxingInfo({'id': idss}).then(response => {
                this.form = response.data;
                this.form.zuJin = this.form.zuJin / 100
                this.form.yaJin = this.form.yaJin / 100
                this.form.wuYeFei = this.form.wuYeFei / 100
                this.form.fangWifi = this.form.fangWifi.toString()
                this.form.fangChuang = this.form.fangChuang.toString()
                this.form.fangYan = this.form.fangYan.toString()
                this.open = true;
                this.title = "修改房型设置";
                setTimeout(() => {
                    this.$refs.uploadImage.clearImages();
                    this.$refs.uploadImage.fillphotos(this.form.fangImg);
                }, 1000)
            });
        },
        /** 提交按钮 */
        submitForm() {
            this.$refs["form"].validate(valid => {
                if (valid) {
                    this.form.zuJin = this.form.zuJin * 100
                    this.form.yaJin = this.form.yaJin * 100
                    this.form.wuYeFei = this.form.wuYeFei * 100
                    this.form.fangBuju = this.form.fangBuju.join(',');
                    this.form.fangWuzhangai = this.form.fangWuzhangai.join(',');
                    this.form.fangWangluo = this.form.fangWangluo.join(',');
                    this.form.fangWeiyu = this.form.fangWeiyu.join(',');
                    this.form.fangJingguan = this.form.fangJingguan.join(',');
                    if (this.form.id != null) {
                        editFangxing(this.form).then(response => {
                            console.log(response);
                            this.$modal.msgSuccess("修改成功");
                            this.open = false;
                            this.getList();
                        });
                    } else {
                        //console.log(JSON.stringify(this.form));
                        //return;
                        this.form.id = '';
                        this.form.fangImg = this.form.fangImg.join(',');
                        this.form.fangBuju = this.form.fangBuju.join(',');
                        this.form.fangWuzhangai = this.form.fangWuzhangai.join(',');
                        this.form.fangWangluo = this.form.fangWangluo.join(',');
                        this.form.fangWeiyu = this.form.fangWeiyu.join(',');
                        this.form.fangJingguan = this.form.fangJingguan.join(',');
                        addFangxing(this.form).then(response => {
                            console.log(response);
                            this.$modal.msgSuccess("新增成功");
                            this.open = false;
                            this.getList();
                        });
                    }
                }
            });
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            const idss = (row.id || this.ids.join(','));
            this.$modal.confirm('是否确认删除数据项？').then(function () {
                return delFangxing({'ids': idss});
            }).then(() => {
                this.getList();
                this.$modal.msgSuccess("删除成功");
            }).catch(() => {
            });
        },
        /** 导出按钮操作 */
        handleExport() {
            // this.download('fang/fangxing/export', {
            //   ...this.queryParams
            // }, `fangxing_${new Date().getTime()}.xlsx`)
        }
    }
};
</script>
<style scoped>
.mb8 {
    height: 50px;
    line-height: 50px;
    background: #fff;
    margin: 20px !important;
    width: calc(100% - 40px);
}

.list {
    margin: 20px;
    width: calc(100% - 40px);
}
</style>
